import { render } from "./search.vue?vue&type=template&id=01f4294e"
const script = {}
script.render = render

export default script